
import React from 'react';

interface PPGDisplayProps {
  ppg: number;
}

const getBackgroundColorForPPG = (ppg: number): string => {
  if (ppg >= 2) return 'bg-emerald-500 text-white';
  if (ppg >= 1.5) return 'bg-emerald-400 text-white';
  if (ppg >= 1) return 'bg-amber-400 text-black';
  return 'bg-red-500 text-white';
};

export const PPGDisplay: React.FC<PPGDisplayProps> = ({ ppg }) => {
  return (
    <div className={`inline-flex items-center justify-center px-2 py-0.5 text-sm font-semibold ${getBackgroundColorForPPG(ppg)} rounded-md min-w-[45px]`}>
      {ppg.toFixed(2)}
    </div>
  );
};
